import type { CheckoutConfig } from '#types/config/checkout'
import type { RecursivePartial } from '#types/utils'

export default {
  showClearSessionButton: true,
  showEmployeeInput: true
} satisfies RecursivePartial<CheckoutConfig['buyInStore']>
